import { Component, OnDestroy, OnInit } from '@angular/core';
import { ServicioService} from 'app/services/servicio.services';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import swal from 'sweetalert2';
import { newContraseña } from 'app/models/ejemplo.model';
import { Console } from 'console';

@Component({
  selector: 'app-obras',
  templateUrl: './obras.component.html',
  styleUrls: ['./obras.component.css']
})
export class ObrasComponent implements OnInit, OnDestroy {

  dtOptions:any;
  Obras: any[];
  dtTrigger: Subject<any> = new Subject<any>();
  constructor(private _servicios: ServicioService, private _router: Router) { }
  private Cliente;
  
  ngOnInit() {
    if(sessionStorage.getItem("token")== null){
      this._router.navigateByUrl("login");
    }   
    if(sessionStorage.getItem("flag") == "true"){
      this._router.navigateByUrl("cambio-pass")
    }
    if(sessionStorage.getItem("email") == "true"){
      this.cambioCorreo();     
    }

    /* opciones tabla*/
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 25,
      language: {
        processing: "Procesando...",
        search: "Buscar:",
        lengthMenu: "Mostrar _MENU_  registros",
        info: "Mostrando desde _START_ al _END_ de _TOTAL_ elementos",
        infoEmpty: "Mostrando ningún elemento.",
        infoFiltered: "(filtrado _MAX_ elementos total)",
        infoPostFix: "",
        loadingRecords: "Cargando registros...",
        zeroRecords: "No se encontraron registros",
        emptyTable: "No hay datos disponibles en la tabla",
        paginate: {
          first: "Primero",
          previous: "Anterior",
          next: "Siguiente",
          last: "Último",
          
        },
        aria: {
          sortAscending: ": Activar para ordenar la tabla en orden ascendente",
          sortDescending: ": Activar para ordenar la tabla en orden descendente"
        },
        
      },
      dom: 'Bfrtip',
      buttons: [
       {extend: 'copy',
        text: 'Copiar'},
        {
          extend: 'excel',
          text: 'Exportar a Excel'
        },
        {
          extend: 'print',
          text: 'Vista de impresión'
        }
    ]
      
    };
    
    this.obtenerCliente();
    this.obtenerObrasVigentes();

  }
  ngOnDestroy(): void{
    this.dtTrigger.unsubscribe();
  }

  cambioCorreo(){
    console.log("pedir correo");
    swal({
      title: 'Ingrese su correo de contacto',
      input: 'email',
      // inputAttributes: {
      //   autocapitalize: 'off'
      // },
      confirmButtonText: 'Ingresar',
      showLoaderOnConfirm: true,
      preConfirm: (mail) => {
        if ((mail == "")) {
          swal("Debe ingresar un e-mail", "", "error");
          
        }
        else {
          console.log("mail");
          this.cambioemail(mail);
        }
      },
      allowOutsideClick: false
    });
  }

  cambioemail(mail: string){
    //funcion de guardar correo.
          var email = new newContraseña();
          email.email = mail;
          email.cliente = sessionStorage.getItem("cliente");
          email.user = sessionStorage.getItem("usuario");
          this._servicios.cambiarCorreo(email).subscribe(
            result=>{
              swal("E-mail actualizado", "", "success");
              sessionStorage.setItem('email', "false");
            }
          );
  }

  obtenerCliente(){
    this._servicios.obtenerDatosCliente(sessionStorage.getItem("cliente")).subscribe(
      result =>{
        this.Cliente = result;
        console.log(this.Cliente);
      }, error => {
        
        this._router.navigateByUrl("login");
    });
    
  }


  obtenerObrasVigentes(){
    this._servicios.obtenerObrasVigentes(sessionStorage.getItem("cliente")).subscribe(
      result =>{
        
        this.Obras = result;
        //console.log(this.Obras);
        this.dtTrigger.next();
      }, error => {
        
        this._router.navigateByUrl("login");
    });
  }

  verResultado(codigo: any){
    sessionStorage.setItem("CodObra",codigo);
    this._router.navigateByUrl("Resultado")

      console.log(codigo);
  }

}



// WEBPACK FOOTER //
// ./src/app/obras/obras.component.ts